import WorkItem from './WorkItem';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import { getWorkItem, setWorkItem } from './WorkItemActions';
import { getWorkSheet } from '../WorkSheets/WorkSheetsActions';
import { getProducts } from '../Products/ProductsActions';
import {logoutAndRedirect} from '../Auth/AuthActions';
import moment from 'moment';

const mapStateToProps=(state)=>{
  const baseValues = state.workitem.workitem;
  const workingTimes = state.app.constants.working_time;
  const normalTime = workingTimes && workingTimes.find(t=>t.name==="normal day");
  const worksheet = state.worksheets.worksheet;
  let initialValues = baseValues;
  if (baseValues) {
    let updated = null;
    if (!baseValues.working_time && normalTime) {
      updated = {...baseValues, working_time: normalTime};
    }
    const currentValues = updated || baseValues;
    if (!currentValues.date && worksheet && worksheet.month) {
      const today = moment();
      const date = today.format('YYYYMM') === '' + worksheet.month
        ? today
        : moment(worksheet.month + '01');
      updated = {...currentValues, date: date.toDate()};
    }
    initialValues = updated || baseValues;
  }
  return {
    initialValues,
    error:state.workitem.error,
    workitem_saved:state.workitem.workitem_saved,
    products_loaded:state.products.products_loaded,
    working_time:workingTimes,
    products:state.products.items,
    worksheet,
    worksheets:state.worksheets.items
  }
}

const mapDispatchToProps=(dispatch)=>{
  return {
    getWorkSheet:(worksheet_id)=>{dispatch(getWorkSheet(worksheet_id))},
    getWorkItem:(worksheet_id,id)=>{dispatch(getWorkItem(worksheet_id,id))},
    setWorkItem:(worksheet_id,wi)=>{dispatch(setWorkItem(worksheet_id,wi))},
    getProducts:()=>{dispatch(getProducts())},
    logout:()=>{dispatch(logoutAndRedirect())},
    goBack:()=>{dispatch(goBack())}
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(WorkItem);
